'use client';

import { useFormContext } from 'react-hook-form';
import { ComfortDetails } from '@/app/(main)/clients/create/components/CreateClientComformDetails';
import { TextArea } from '@/app/components/form/TextArea';
import type { CreateClientFormData } from '@/types/clientsApiTypes';

const MAX_INFO_LENGTH = 300;

export const EditRelatedComfortDetailsForm = () => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<CreateClientFormData>();
  const informationValue = watch('primary_passenger.preference_data.personal.information') ?? '';

  return (
    <div className="flex flex-col gap-4">
      <ComfortDetails
        fieldPrefix="primary_passenger.preference_data"
        intent="primaryWhite"
        tabsIntent="default"
        mobileHeaderLayout="stacked"
        helperText="Used only when helpful for specific adventure activities (e.g., required for African safaris, certain small airlines/aircraft, biking excursions, scuba diving, etc.)"
      />
      <TextArea
        {...register('primary_passenger.preference_data.personal.information')}
        value={informationValue}
        disableResize
        placeholder="Please share any personal information you'd like us to be aware of that may help us better support you or this traveler. This may include preferences, sensitivities, accessibility needs, or any accommodations that would help ensure a comfortable travel experience."
        rows={6}
        size="flexible_height"
        maxLength={MAX_INFO_LENGTH}
        errors={errors}
      />
    </div>
  );
};